import React from 'react';

interface LoaderProps {
    size?: 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
    fullScreen?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({
    size = 'md',
    className = '',
    fullScreen = false,
}) => {
    const sizes = {
        sm: 'w-5 h-5',
        md: 'w-8 h-8',
        lg: 'w-12 h-12',
        xl: 'w-16 h-16',
    };

    const loaderContent = (
        <div className="flex flex-col items-center gap-4">
            {/* Premium dual-ring loader */}
            <div className={`relative ${sizes[size]} ${className}`}>
                {/* Outer ring - brand color, rotates clockwise */}
                <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-brand border-r-brand animate-spin" />

                {/* Inner ring - brand/30, rotates counter-clockwise */}
                <div className="absolute inset-2 rounded-full border-2 border-transparent border-t-brand/30 border-l-brand/30 animate-[spin_1.5s_linear_infinite_reverse]" />

                {/* Pulsing center dot */}
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-1.5 h-1.5 rounded-full bg-brand animate-pulse" />
                </div>
            </div>

            {/* Only show text in fullscreen mode */}
            {fullScreen && (
                <div className="text-xs text-white/30 uppercase tracking-widest font-medium animate-pulse">
                    Loading...
                </div>
            )}
        </div>
    );

    if (fullScreen) {
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-deep-black/95 backdrop-blur-xl">
                {loaderContent}
            </div>
        );
    }

    return loaderContent;
};
